// Suffixes to ignore when extracting last name (generational, honorific, ordinal)
const SUFFIX_RE = /^(jr\.?|sr\.?|esq\.?|i{1,3}|iv|vi{0,3}|ix|x{1,2}|\d+(?:st|nd|rd|th))$/i;

export function getLastName(displayName) {
  if (!displayName) return '';
  const parts = displayName.trim().split(/\s+/);
  while (parts.length > 1 && SUFFIX_RE.test(parts[parts.length - 1])) {
    parts.pop();
  }
  return parts[parts.length - 1]?.toLowerCase() || '';
}

export function getFirstName(displayName) {
  if (!displayName) return '';
  return displayName.trim().split(/\s+/)[0]?.toLowerCase() || '';
}

export function getNameSortKey(displayName, by) {
  return by === 'firstName' ? getFirstName(displayName) : getLastName(displayName);
}
